export const capitalize = (str) => {
  if (str) return str.charAt(0).toUpperCase() + str.slice(1);
};

export const flatten = (array) => {
  if (!Array.isArray(array)) {
    return [];
  }

  const result = array.reduce((a, b) => a.concat(b), []);
  return result;
};

export const isEmpty = (value) => {
  if (!value) return true;

  if (typeof value === 'number') {
    return true;
  }

  if (typeof value === 'string') {
    return value.length === 0;
  }

  if (typeof value === 'object') {
    if (Array.isArray(value)) {
      return value.length === 0;
    }

    return Object.keys(value).length === 0;
  }

  return true; // Boolean (true)
};

export const minBy = (array, fn) => {
  if (!Array.isArray(array) || !fn) {
    return undefined;
  }

  if (array.length === 0) {
    return undefined;
  }

  const minItem = array.reduce((a, b) => {
    if (typeof fn === 'function') {
      return fn(a) <= fn(b) ? a : b;
    }

    if (typeof fn === 'string') {
      return a[fn] <= b[fn] ? a : b;
    }
  });

  return minItem;
};

export const shuffle = (array) => {
  if (!Array.isArray(array)) {
    return [];
  }

  for (let i = array.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[j], array[i]] = [array[i], array[j]];
  }

  return array;
};

export const sampleSize = (array, sample = 0) => {
  const shuffled = shuffle(array);
  const result = shuffled.slice(0, sample);
  return result;
};

export const times = (value) => {
  if (!value || typeof value !== 'number') {
    return [];
  }

  const result = [];
  for (let i = 0; i < value; i += 1) {
    result.push(i);
  }

  return result;
};

export const slugToCamelCase = (slug) => {
  if (!slug) return null;

  const words = slug.split('-');
  const camelCaseWords = words.map((word, index) => {
    if (index === 0) return word;
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
  const camelCase = camelCaseWords.join('');
  return camelCase;
};
